import { HomeOutlined, MenuOutlined } from '@ant-design/icons'
import { useToggle } from 'ahooks'
import { Avatar } from 'antd'
import cls from 'classnames'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { AppHeader } from '@/components'
import { useAppStateQuery, useGetViewerQuery } from '@/generated/graphql'
import { AnniversaryCardContainer } from '@/modules/anniversary-card/anniversary-card.container'
import { AnnouncementContainer } from '@/modules/announcement/announcement.container'
import { AsideContainer } from '@/modules/aside/aside.container'
import { OnboardingContainer } from '@/modules/onboarding/onboarding.container'
import { SearchInput } from '@/modules/search'
import { Routes, routes } from '@/routes'

import { AnnualReportContainer } from '../annual-report/annual-report.container'
import s from './app.module.less'

export const WebsiteSetCommonContext = React.createContext({ visible: false, toggle: () => {} })

export const App = () => {
  const location = useLocation()
  const { data: appStateData } = useAppStateQuery()
  const [visible, { toggle }] = useToggle()

  return (
    <div className={s.layout}>
      <WebsiteSetCommonContext.Provider value={{ visible, toggle }}>
        <AsideContainer />
        <main
          className={cls(
            s.main,
            {
              [s.hideSideBar]: !appStateData!.appState.showSidebar,
            },
            {
              [s.showSearchHeader]: appStateData!.appState.showSearchHeader,
            }
          )}
        >
          <Routes />
        </main>
      </WebsiteSetCommonContext.Provider>
      {location.pathname.includes(routes.annualReport.home()) && <AnnualReportContainer />}
      <Footer />
      {location.pathname === '/' && <AnniversaryCardContainer />}
      <AnnouncementContainer />
      <OnboardingContainer />
    </div>
  )
}

const Footer = () => {
  const history = useHistory()
  const { data } = useGetViewerQuery()
  return (
    <div className={s.footer}>
      <div onClick={() => history.push(routes.section.updates())}>
        <HomeOutlined />
      </div>
      <div onClick={() => history.push(routes.menu())}>
        <MenuOutlined />
      </div>
      <div onClick={() => history.push(routes.me.home())}>
        <Avatar src={data!.viewer.avatarUrl} />
      </div>
    </div>
  )
}

export const SearchHeader: React.FC<{ title?: React.ReactElement | null; avatar?: React.ReactElement | null }> = ({
  title,
  avatar,
}) => {
  return (
    <>
      <div className={s.searchHeader}>
        <SearchInput title={title} />
      </div>
      <div className={s.generalHeader}>
        <AppHeader title={title} avatar={avatar} />
      </div>
    </>
  )
}
